export const CLASS_COLOR_TAGS = 'color-tags';
